import Fill from './fill.svg?react';
import Height from './height.svg?react';
import Length from './length.svg?react';
import Mass from './mass.svg?react';
import SectionArea from './section-area.svg?react';
import SideArea from './side-area.svg?react';
import TopArea from './top-area.svg?react';
import Volume from './volume.svg?react';
import Width from './width.svg?react';

export const QuantityIcons = {
  Fill,
  Height,
  Length,
  Mass,
  SectionArea,
  SideArea,
  TopArea,
  Volume,
  Width,
};
